import { useMsal } from '@azure/msal-react';
import { LogIn, X } from 'lucide-react';
import { getBackofficeLoginRequest } from './config';
import { useBackofficePageTitle } from '@/lib/page-title';

export function LoggedOutPage() {
  const { instance } = useMsal();

  useBackofficePageTitle('Signed out');

  return (
    <main className="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(223,244,236,0.95),_rgba(255,255,255,1)_48%)] px-6 py-12 text-neutral-900">
      <div className="w-full max-w-xl rounded-[28px] border border-neutral-200 bg-white p-8 shadow-soft md:p-10">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-backoffice-700">
          Backoffice
        </p>
        <h1 className="mt-4 font-inter-tight text-4xl font-semibold tracking-[-0.03em] text-neutral-900">
          You are signed out
        </h1>
        <p className="mt-4 max-w-lg text-body text-neutral-600">
          Your backoffice session has ended. You can sign in again with another account or close
          this window.
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <button
            type="button"
            className="focus-ring inline-flex items-center justify-center gap-2 rounded-lg bg-backoffice-600 px-5 py-3 text-small font-semibold text-white transition hover:bg-backoffice-700"
            onClick={() => {
              void instance.loginRedirect(getBackofficeLoginRequest());
            }}
          >
            <LogIn className="h-4 w-4" aria-hidden="true" />
            <span>Log in again</span>
          </button>
          <button
            type="button"
            className="focus-ring inline-flex items-center justify-center gap-2 rounded-lg border border-neutral-200 bg-white px-5 py-3 text-small font-semibold text-neutral-700 transition hover:bg-neutral-50"
            onClick={() => {
              window.close();
            }}
          >
            <X className="h-4 w-4" aria-hidden="true" />
            <span>Close window</span>
          </button>
        </div>
      </div>
    </main>
  );
}
